<template>
  <b-card class="container-card">
    <div class="font-welcome mx-2">
      Welcome to Back-Office BCRM PLATFORM !
    </div>
    <div class="content-img-welcome">
      <img class="img-welcome" :src="WelcomeImg" alt="" draggable="false" />
    </div>
  </b-card>
</template>

<script>
import { onBeforeMount, getCurrentInstance } from "vue-demi";
import WelcomeImg from "@/assets/images/pages/landing/Vector-Welcome.png";
import useLoginAction from "@/views/pages/authentication/login/hooks/useLoginAction";

export default {
  setup() {
    const vm = getCurrentInstance().proxy;
    const { fetchBrandInfo, getBrandListInfo } = useLoginAction();

    onBeforeMount(() => {
      fetchBrandInfo().then((value) => {
        // flow change brand
        getBrandListInfo(value);
      });
    });

    return {
      WelcomeImg,
    };
  },
};
</script>

<style scoped>
.font-welcome {
  font-size: 44px;
}

.content-img-welcome {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding: 5vw 0 8vw;
  width: 100%;
  height: 90%;
}

.img-welcome {
  width: 70%;
}

.coming-soon-text {
  text-align: center;
  margin-top: 2rem;
  font-size: 7vw;
  color: #383856;
}
</style>
